import React from 'react'
import Box from '@mui/material/Box'
import TableSort from '../tableComponents/TableSort'
import { variableName } from "../js/constants"
import { formatDateRange, formatHourFilter, formatDayFilter } from "../js/utilityRoutines"

export default function ExthrlyTable(props) { 
  const { tabledata, sumObs, sumMiss, userParams, stnName } = props;
  const dateRange = formatDateRange(userParams);
  const dayFilter =  formatDayFilter(userParams);
  const hourFilter = formatHourFilter(userParams);
  const totObs = sumObs.toLocaleString("en");
  const totMiss = sumMiss.toLocaleString("en");
  const multihr = userParams.numhrs > 1;
  const variable = userParams.variable;
  const titleText = (multihr ? userParams.numhrs + "-Hour" : "Hourly") + " Extreme " + variableName[variable].name + 
     " Values (" + variableName[variable].units + ") <br/ >" + stnName;
  const footerText = "Based on a total of " + totObs + 
    (multihr ? " " + userParams.numhrs + "-hour periods; " : " hourly observations; ") + totMiss + 
    (multihr ? " periods" : " hours") + " missing" + 
    (["htindx", "wchill"].includes(variable) ? " or conditions not met for index calculation." : ".") +
    "<br />" + dateRange +
    (dayFilter ? "<br />" : "") + dayFilter + (dayFilter ? "." : "") +
    (hourFilter ? "<br />" : "") + hourFilter;
  const heads = [
    {text: 'index', id: 'index', invisible: true, initSort: true, sortOrder: 'asc'},
    {text: 'Rank', id: 'rank', altSort: 'index'},
    {text: variableName[variable].name, id: 'val'},
    {text: (multihr ? 'Ending ' : '') + 'Date/Hour', id: 'dt'},
  ]

  return (
    <Box sx={{my: 1}}>
      <TableSort 
        titleText={titleText} 
        heads={heads}  
        tableNoSortData={tabledata}
        footerText={footerText}
        doNotSort={true}
      />
    </Box>
  )
}
